import { COUNTRY_CODES, DELIVERY_TYPES, PACKAGE_TYPE } from '../helpers/constans';
import formData from '../helpers/form-data';

const axios = require('axios');

// eslint-disable-next-line
const URL_PREFIX = urlPrefix;
// eslint-disable-next-line no-undef
const NEW_API_URL = apiUrl;

const PRICE_ITEM = 0;

function requestHasFailed(resp) {
  return !Object.prototype.hasOwnProperty.call(resp, 'status') || resp.data.status !== 1 || resp.data.error;
}

function requestHasError(resp) {
  return resp.data.error;
}

function parseError(resp, errorDictionary) {
  if (requestHasFailed(resp)) {
    if (resp.data.err && typeof resp.data.err === 'object') {
      const errArr = Object.keys(resp.data.err)
        .map((errorKey) => {
          if (errorKey === 'calc' && resp.data.err[errorKey] === 'Тариф не найден') {
            return 'К сожалению, отправка по данному направлению временно приостановлена';
          }

          if (errorKey === 'receiver-office-id' && resp.data.err[errorKey] === 'Выберите отделение Boxberry') {
            return 'Произошла ошибка. Вернитесь на 2 шаг и выберите другие пункты доставки. ';
          }

          if (errorDictionary !== undefined && errorDictionary[errorKey] === '') {
            return (`${resp.data.err[errorKey]}`);
          }

          if (errorDictionary !== undefined && errorDictionary[errorKey] !== undefined) {
            return (`${errorDictionary[errorKey]}: ${resp.data.err[errorKey]}`);
          }
          return 'Произошла ошибка, попробуйте повторить позже.';
        });
      return new Error(errArr);
    }
    if (resp.data.err && resp.data.err === 'Array') {
      return new Error('Произошла ошибка. Вернитесь на 2 шаг и выберите другие пункты доставки. ');
    }
    return new Error('Произошла ошибка, попробуйте повторить позже.');
  }

  throw new Error('Unable to parse error. Response has been successfull');
}

function parseStringError(resp, errorDictionary) {
  if (requestHasError(resp)) {
    const errArr = resp.data.messages.map((item) => {
      if (typeof item === 'object') {
        const key = Object.keys(item)[0];
        let result = {
          label: '',
          text: item[key],
        };
        Object.keys(errorDictionary).forEach((errorDictionaryItem) => {
          if (key.indexOf(errorDictionaryItem) !== -1) {
            result = {
              label: errorDictionary[errorDictionaryItem],
              text: item[key],
            };
          }
        });
        return result;
      }
      let result = {
        label: '',
        text: item,
      };
      Object.keys(errorDictionary).forEach((errorDictionaryItem) => {
        if (item.indexOf(errorDictionaryItem) !== -1) {
          result = {
            label: errorDictionary[errorDictionaryItem],
            text: item.replace(errorDictionaryItem, ''),
          };
        }
      });
      return result;
    });
    return errArr;
  }

  throw new Error('Unable to parse error. Response has been successfull');
}

function calculate(orderCalcPIP, errorDictionary, salePip, calcImport) {
  const params = {
    sender_city: orderCalcPIP.sender.city,
    // sender_city_name: orderCalcPIP.sender.cityName,
    sender_country: orderCalcPIP.sender.country,
    receiver_city: orderCalcPIP.receiver.city,
    // receiver_city_name: orderCalcPIP.receiver.cityName,
    receiver_country: orderCalcPIP.receiver.country,
    public_price: orderCalcPIP.public_price.replace(' ', '') * 100,
    'package[boxberry_package]': orderCalcPIP.package.type,
    list_services: orderCalcPIP.list_services,
    promo_code: orderCalcPIP.forcePromocode || orderCalcPIP.promo_code,
  };
  if (orderCalcPIP.package.type === PACKAGE_TYPE.BOXBERRY) {
    params['package[package_code]'] = orderCalcPIP.package.package_id;
  } else {
    params['package[width]'] = orderCalcPIP.width;
    params['package[height]'] = orderCalcPIP.height;
    params['package[depth]'] = orderCalcPIP.depth;
  }
  if (orderCalcPIP.weight && calcImport) {
    params.weight = orderCalcPIP.weight;
  }
  if (salePip && !calcImport) {
    params.sale_pip = '';
  }

  return new Promise((resolve, reject) => {
    const url = URL_PREFIX ? `${URL_PREFIX}proxy/delivery/cost/pip?method=TarificationLaP` : '/proxy/delivery/cost/pip?method=TarificationLaP';
    axios.get(url, { params })
      .then((resp) => {
        if (requestHasFailed(resp)) {
          reject(parseError(resp, errorDictionary));
        } else {
          const resultData = resp.data.data
            .filter((item) => (!(orderCalcPIP.sender.country === COUNTRY_CODES.RUSSIA && orderCalcPIP.receiver.country !== COUNTRY_CODES.RUSSIA)
              || (item.delivery_type === DELIVERY_TYPES.PVZ_TO_PVZ || item.delivery_type === DELIVERY_TYPES.PVZ_TO_DOOR)))
            .map((item) => ({
              delivery_type: item.delivery_type,
              cost: item.price,
              discount: item.promocode_discount,
              time: item.time,
              checkIndex: [DELIVERY_TYPES.PVZ_TO_DOOR, DELIVERY_TYPES.DOOR_TO_PVZ, DELIVERY_TYPES.DOOR_TO_DOOR].includes(item.delivery_type),
              showPrice: ![DELIVERY_TYPES.PVZ_TO_DOOR, DELIVERY_TYPES.DOOR_TO_PVZ, DELIVERY_TYPES.DOOR_TO_DOOR].includes(item.delivery_type),
              showSender: item.delivery_type === 1 || item.delivery_type === 2,
              showReceiver: item.delivery_type === 1 || item.delivery_type === 3,
              showAddressForm: false,
              zipSuccess: null,
              sender: {
                addressHome: '',
                addressStreet: '',
                addressZip: '',
                zipError: '',
                addressAll: '',
              },
              receiver: {
                addressHome: '',
                addressStreet: '',
                addressZip: '',
                zipError: '',
                addressAll: '',
              },
              ...item,
            }));
          resolve(resultData.reverse());
        }
      })
      .catch((error) => {
        if (requestHasError(error.response)) {
          reject(parseStringError(error.response, errorDictionary));
        }

        reject(new Error('Произошла ошибка. Попробуйте повторить позже.'));
      });
  });
}

function calculateZip(orderCalcPIP, errorDictionary, senderAddressZip, receiverAddressZip, deliveryType, salePip, calcImport) {
  const params = {
    sender_city: orderCalcPIP.sender.city,
    sender_country: orderCalcPIP.sender.country,
    receiver_city: orderCalcPIP.receiver.city,
    receiver_country: orderCalcPIP.receiver.country,
    public_price: orderCalcPIP.public_price.replace(' ', '') * 100,
    'package[boxberry_package]': orderCalcPIP.package.type,
    list_services: orderCalcPIP.list_services,
    promo_code: orderCalcPIP.forcePromocode || orderCalcPIP.promo_code,
    delivery_type: deliveryType,
  };
  if (orderCalcPIP.package.type === PACKAGE_TYPE.BOXBERRY) {
    params['package[package_code]'] = orderCalcPIP.package.package_id;
  } else {
    params['package[width]'] = orderCalcPIP.width;
    params['package[height]'] = orderCalcPIP.height;
    params['package[depth]'] = orderCalcPIP.depth;
  }
  if (senderAddressZip) {
    params.sender_zip = senderAddressZip;
  }
  if (receiverAddressZip) {
    params.receiver_zip = receiverAddressZip;
  }
  if (orderCalcPIP.weight && calcImport) {
    params.weight = orderCalcPIP.weight;
  }
  if (salePip && !calcImport) {
    params.sale_pip = '';
  }

  return new Promise((resolve, reject) => {
    const url = URL_PREFIX ? `${URL_PREFIX}proxy/delivery/cost/pip?method=TarificationLaP` : '/proxy/delivery/cost/pip?method=TarificationLaP';
    axios.get(url, { params })
      .then((resp) => {
        if (requestHasFailed(resp)) {
          reject(parseError(resp, errorDictionary));
        } else {
          const resultData = resp.data.data;
          resolve(resultData.reverse());
        }
      })
      .catch(() => {
        reject(new Error('Произошла ошибка. Попробуйте повторить позже.'));
      });
  });
}


function submitOrder(orderPIP, errorDictionary, orderCalcPIP, salePip, items, isCustoms, totalPrice) {
  return new Promise((resolve, reject) => {
    const url = URL_PREFIX ? `${URL_PREFIX}proxy/pip/order/new?method=neworder`
      : '/proxy/pip/order/new?method=neworder';
    const params = {
      ...orderPIP,
      package: {
        attachment: orderPIP.package.attachment,
        boxberry_package: orderCalcPIP.package.type,
      },
    };
    if (orderCalcPIP.package.type === PACKAGE_TYPE.BOXBERRY) {
      params.package.package_id = orderCalcPIP.package.package_id;
    } else {
      params.package.width = orderCalcPIP.width;
      params.package.height = orderCalcPIP.height;
      params.package.depth = orderCalcPIP.depth;
    }
    if (orderCalcPIP.return_point) {
      params.sender.point = orderCalcPIP.return_point;
    }
    if (!orderPIP.sender.document_num && !orderPIP.sender.document_series) {
      params.sender.document_type = '';
    }
    if (orderCalcPIP.sender.country) {
      params.sender.country_code = orderCalcPIP.sender.country;
    }
    if (orderCalcPIP.receiver.country) {
      params.receiver.country_code = orderCalcPIP.receiver.country;
    }
    if (salePip) {
      params.sale_pip = '';
    }
    if (orderCalcPIP.forcePromocode) {
      params.promo_code = orderCalcPIP.forcePromocode;
    }
    if (isCustoms && items) {
      params.items = items.map((item) => ({ ...item, price: item.price.replace(/\s/g, '') }));
    }
    if (isCustoms) {
      params.custom = true;
    }
    params.prepayd_sum = totalPrice * 100;

    const config = URL_PREFIX ? ({
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    }) : {};

    axios.post(url, params, config)
      .then((resp) => {
        if (requestHasFailed(resp)) {
          reject(parseError(resp, errorDictionary));
        } else {
          resolve(resp.data.order_num);
        }
      });
  });
}

function submitOrderImport(orderPIP, errorDictionary, orderCalcPIP, amount, dataCaptcha, receiverCanPay) {
  return new Promise((resolve, reject) => {
    const url = `${NEW_API_URL}/order/new`;

    const products = orderPIP.themes.map((themeItem) => ({
      name: themeItem.name,
      nds: 20,
      price: PRICE_ITEM,
      quantity: 1,
    }));

    const params = {
      public_price: orderCalcPIP.public_price.replace(' ', '') * 100,
      amount: amount.replace('.', ''),
      sender: {
        phone: orderPIP.sender.phone.replace(/\D/g, ''),
        email: orderPIP.sender.email,
        name: orderPIP.sender.name,
        passport: orderPIP.sender.document_num,
        point: orderPIP.sender.point,
      },
      receiver: {
        phone: orderPIP.receiver.phone.replace(/\D/g, ''),
        email: orderPIP.receiver.email,
        name: orderPIP.receiver.name,
        point: orderPIP.receiver.point,
      },
      products,
      package: [
        {
          box_weight: orderCalcPIP.weight,
          width: orderCalcPIP.width,
          height: orderCalcPIP.height,
          depth: orderCalcPIP.depth,
          barcode: null,
        },
      ],
    };
    if (dataCaptcha) {
      params.captcha = dataCaptcha;
    }
    if (receiverCanPay) {
      params.payer_type = orderPIP.payer_type;
    }
    if (orderCalcPIP.sender.country) {
      params.sender.country_code = orderCalcPIP.sender.country;
    }
    if (orderCalcPIP.receiver.country) {
      params.receiver.country_code = orderCalcPIP.receiver.country;
    }
    const json = JSON.stringify(params);

    axios.post(url, json, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((resp) => {
        if (!resp.data || !resp.data.orderId) {
          reject(parseError(resp, errorDictionary));
        } else {
          resolve(resp.data);
        }
      });
  });
}

function paymentInit(orderPIP, errorDictionary, orderNum, amount, paymentId, orderCalcPIP, paySystem, isDirectionKzKz) {
  return new Promise((resolve, reject) => {
    const url= isDirectionKzKz
        ? `${NEW_API_URL}/payment/init`
        : `${NEW_API_URL}/payment/v2/init`;
    const params= {
      amount,
      'invoice-num': orderNum,
      currency: 'RUB',
      email: orderPIP.sender.email,
      'sender-city': orderPIP.sender.city,
      'sender-point': orderPIP.sender.point,
      'recipient-city': orderPIP.receiver.city,
      'recipient-point': orderPIP.receiver.point,
      'pickup-post': orderPIP.receiver.pointTitle,
      'pickup-address': orderPIP.receiver.pointAddress,
      'sender-post': orderPIP.sender.pointTitle,
      'sender-address': orderPIP.sender.pointAddress,
      id: paymentId,
      'public-price': orderCalcPIP.public_price.replace(' ', '') * 100,
      weight: orderCalcPIP.weight,
      'promo-code': orderCalcPIP.forcePromocode || orderCalcPIP.promo_code,
      'sender-country-code': orderPIP.sender.country,
      'receiver-country-code': orderPIP.receiver.country,
      'recipient-name': orderPIP.receiver.name,
      'payment-system': paySystem,
      path: window.location.href,
    };

    if (isDirectionKzKz) {
      params.path = 'kz-ru';
      params.currency = 'KZT';
      params['goods[0][count]'] = 1;
      params['goods[0][name]'] = 'Доставка посылки';
      params['goods[0][price]'] = amount;
    }

    axios.post(url, formData(params))
      .then((resp) => {
        if (!resp.data && resp.data.status !== 'ok') {
          reject(parseError(resp, errorDictionary));
        } else {
          resolve(resp.data);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  });
}

function sendInfo(orderPIP, errorDictionary, orderCalcPIP, calcImport, comment, step) {
  return new Promise((resolve, reject) => {
    const url = `${NEW_API_URL}/calc/pip/info`;
    const params = {
      sender_city: orderCalcPIP.sender.city,
      receiver_city: orderCalcPIP.receiver.city,
      sender_country: orderCalcPIP.sender.country,
      receiver_country: orderCalcPIP.receiver.country,
      public_price: orderCalcPIP.public_price.replace(' ', '') * 100,
      'package[boxberry_package]': orderCalcPIP.package.type,
      step,
    };
    if (orderCalcPIP.package.type === PACKAGE_TYPE.BOXBERRY) {
      params['package[package_code]'] = orderCalcPIP.package.package_id;
    } else {
      params['package[width]'] = orderCalcPIP.width;
      params['package[height]'] = orderCalcPIP.height;
      params['package[depth]'] = orderCalcPIP.depth;
    }
    if (comment) {
      params.comment = comment;
    }
    if (orderCalcPIP.weight && calcImport) {
      params.weight = orderCalcPIP.weight;
    }

    axios.get(url, { params })
      .then((resp) => {
        if (requestHasFailed(resp)) {
          reject(parseError(resp, errorDictionary));
        } else {
          resolve(resp.data.order_num);
        }
      });
  });
}

export {
  calculate as default, submitOrder, calculateZip, submitOrderImport, paymentInit, sendInfo,
};
